import { render, staticRenderFns } from "./RechargeCampaignTip.vue?vue&type=template&id=16165a56&scoped=true"
import script from "./RechargeCampaignTip.vue?vue&type=script&lang=js"
export * from "./RechargeCampaignTip.vue?vue&type=script&lang=js"
import style0 from "./RechargeCampaignTip.vue?vue&type=style&index=0&id=16165a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16165a56",
  null
  
)

export default component.exports